import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/database',
  title: window.language['menu.sysConfig.config.database'],
  component: dynamicWrapper(app, [import('./model'),import('../../Material/Material/model'),import('../../HomePage/model'),], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/DataBase/index.js